/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Output_DescInputs */

const en_landing_why_output_desc = /** @type {(inputs: Landing_Why_Output_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seven aspect ratios here, from 9:16 stories to 16:9 banners.`)
};

const zh_landing_why_output_desc = /** @type {(inputs: Landing_Why_Output_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持 7 种画面比例，从 9:16 竖版到 16:9 横幅。`)
};

/**
* | output |
* | --- |
* | "Seven aspect ratios here, from 9:16 stories to 16:9 banners." |
*
* @param {Landing_Why_Output_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_output_desc = /** @type {((inputs?: Landing_Why_Output_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Output_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_output_desc(inputs)
	return zh_landing_why_output_desc(inputs)
});
export { landing_why_output_desc as "landing.why.output_desc" }